import React from 'react'
import PubAnnotations from './PubAnnotations'
import AnnotationHeader from './AnnotationHeader'
import ArticleIcon from 'src/images/icons/article_icon.svg'

class ArticleAnnotation extends React.Component {
  constructor(props){
    super(props)
    this.state = { step: 'new', articleId: null, articleTitle: null }
    this.onAddArticleClick = this.onAddArticleClick.bind(this)
    this.onRemoveArticleClick = this.onRemoveArticleClick.bind(this)
    this.saveLateArticle = this.saveLateArticle.bind(this)
    this.articleDropdown = React.createRef();
  }

  onAddArticleClick(e) {
    this.setState({
      step: $(e.target).data('step'),
      articleId: $(e.target).data('step') == 'confirm' ? $(e.target).data('article-id') : null,
      articleTitle: $(e.target).data('step') == 'confirm' ? $(e.target).text() : null
    })
  }

  onRemoveArticleClick(){
    PubAnnotations.init().saveRemoveTypeAnnotation(this.props.annotation, {type: 'Annotation::RemoveArticle'})
  }

  saveLateArticle(){
    PubAnnotations.init().saveLateArticleAnnotation(this.props.annotation, {articleId: this.state.articleId})
  }

  firstStepAction(){
    return (
      <div className="d-flex flex-row justify-content-center pb-4">
        <button className="btn-flat" data-step="select" onClick={this.onAddArticleClick}>Add Article</button>
        <button className="btn-flat" onClick={this.onRemoveArticleClick}>Remove Article</button>
      </div>
    )
  }

  secondStepAction(){
    const classes = this.state.step == 'confirm' ? "d-flex flex-row justify-content-center" : "pb-4 mb-4 d-flex flex-row justify-content-center"
    const text = this.state.step == 'confirm' ? this.state.articleTitle : "Select an article"
    return (
      <div className={classes}>
        <a ref={this.articleDropdown} className="dropdown-button with-chevron" data-activates="articleDropdown">{text}</a>
        <ul className="dropdown-content" style={{'width': '220px'}} id="articleDropdown">
          {this.props.articleOptions.map((article, i) => {
            return <li key={i} onClick={this.onAddArticleClick}><a className="black-text" data-step='confirm' data-article-id={article.id}>{article.title}</a></li>
          })}
        </ul>
      </div>
    )
  }

  componentDidUpdate(){
    if (this.state.step == 'select') {
      $(this.articleDropdown.current).dropdown()
    }
  }

  render() {
    let action;
    let text;
    let addArticleButton;
    switch (this.state.step) {
      case 'new':
        text = <h1>Do you need to add or remove an article?</h1>
        action = this.firstStepAction()
        break;
      case 'select':
        text = <h3>Adding an article? Select an article from your library.</h3>
        action = this.secondStepAction()
        break;
      case 'confirm':
        text = <h3>This article will be added to the publication.</h3>
        action = this.secondStepAction() 
        addArticleButton = (
          <div className="d-flex flex-row justify-content-end pb-4 px-2">
            <button className="btn-flat" onClick={this.saveLateArticle}>Add Article</button>
          </div>
          )
        break;
    }

    return (
      <div className="card p-0">
        <AnnotationHeader
          onSelect={this.props.onSelect}
          annotation={this.props.annotation}
          roleType={this.props.roleType}
          annotationTypes={this.props.annotationTypes} />
        <div className="text-center py-5 grey-text text-darken-2 px-9">
          <img className='m-auto pb-2' src={ArticleIcon}/>
          {text}
        </div>
        {action}
        {addArticleButton}
      </div>
      )
  }
}

export default ArticleAnnotation
